import { FC } from 'react';

import { DocusignIcon } from '../../../../assets/icons/docusign-icon';
import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { Tooltip } from '../../../../components/tooltip/index';
import { useSelectedCompany } from '../../../../hooks/index';
import { EventsModalType } from '../../../events/enums/events-modal-type.const';
import { eventsModalStore } from '../../../events/store/events-modal.store';

export const DocusignEnvelopeUsageIndicator: FC = () => {
  const { selectedCompany } = useSelectedCompany();
  const envelope = selectedCompany?.docusignEnvelope;

  if (!envelope) {
    return null;
  }

  const openGetMoreEnvelopesModal = () => {
    eventsModalStore.getState().openModal({ type: EventsModalType.GET_MORE_ENVELOPES });
  };

  const tooltipContent = (
    <span className="flex max-w-[240px] flex-col gap-1 text-left text-xs font-normal normal-case">
      <AppFormattedMessage id="ENVELOPE_USAGE_TOOLTIP" />
      <span>
        <AppFormattedMessage id="ENVELOPE_USAGE_REQUEST_MORE_PREFIX" />{' '}
        <button
          className="font-[550] underline"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            openGetMoreEnvelopesModal();
          }}
          type="button"
        >
          <AppFormattedMessage id="CLICK_HERE_SMALL" />
        </button>
        .
      </span>
    </span>
  );

  return (
    <Tooltip className="max-w-[280px]" content={tooltipContent} placement="bottom">
      <div className="mx-1 flex h-9 shrink-0 items-center gap-2 rounded-[4px] bg-brand-25 px-3">
        <DocusignIcon className="size-5" />
        <span className="text-sm text-gray-700">
          <AppFormattedMessage id="ENVELOPE_USAGE" />
        </span>
        <span className="text-sm font-[550] text-brand-700">
          {envelope.remaining}/{envelope.limit}
        </span>
      </div>
    </Tooltip>
  );
};
